import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { SalesOrderOutline } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2321. setup_intentのclient_secret取得
 * [GET] /workspaces/:identifier/setup_intent_client_secret
 */
type Props = {
  identifier: string;
};
type SetupIntentClientSecret = {
  client_secret: string;
};
const setupIntentClientSecret = (props: Props): Promise<SetupIntentClientSecret> => {
  return axios.get(`/api/workspaces/${props.identifier}/setup_intent_client_secret`);
};

export const useSetupIntentClientSecret = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => setupIntentClientSecret(props),
  });
};

export const setupIntentClientSecretInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'setup_intent_client_secret'];
};
